// extracted by mini-css-extract-plugin
module.exports = {"root":"TeaserFlag_root__MToiW"};